import { render, staticRenderFns } from "./AdminProductHistory.vue?vue&type=template&id=2dda4641&scoped=true&"
import script from "./AdminProductHistory.vue?vue&type=script&lang=js&"
export * from "./AdminProductHistory.vue?vue&type=script&lang=js&"
import style0 from "./AdminProductHistory.vue?vue&type=style&index=0&id=2dda4641&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dda4641",
  null
  
)

export default component.exports